import { useRequest } from 'ahooks';
import { request_domainsList } from '../request/salesChannel/setting/domain';
import { useParams } from 'react-router-dom';
import {
  postContentPagePreview,
  postHomePagePreview,
} from '../request/salesChannel/content';
import { useSalesChannelContent } from './useSalesChannelContent';

function usePreviewService(isContentPage?: boolean) {
  const _params: any = useParams();
  const { saleChannelUuid } = _params;
  const { salesChannelMultiLanguageQueryParams, selectedLanguage } =
    useSalesChannelContent();
  const queryParams = salesChannelMultiLanguageQueryParams;
  const { data } = useRequest(() => request_domainsList(saleChannelUuid));
  const { run, loading } = useRequest(
    (data, params) => {
      return isContentPage
        ? postContentPagePreview(data, params)
        : postHomePagePreview(data, params);
    },
    { manual: true },
  );
  const getDomains = (domains: Array<any>) => {
    const v = domains.find((v) => v.status === 'Connected');
    return v ? v?.domain : '';
  };
  const domain = getDomains(data?.domains || []);
  const onPreview = async (data: any) => {
    const res = await run(data, queryParams);
    const date = res?.previewCreatedAt;
    const url = `https://${domain}/${selectedLanguage}/preview?pt=${
      res?.previewToken
    }&pe=${date}&type=${isContentPage ? 2 : 1}`;
    setTimeout(() => {
      window.open(url, '_blank');
    }, 1 * 1000);
  };

  return {
    onPreview,
    loading,
  };
}

export default usePreviewService;
